import React, { useState, useEffect, useCallback } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'
import Loader from 'views/shared/partials/loader'
import Pricebox from 'views/shared/partials/pricebox'

// Utils
import { openModal } from 'utils/modals'

// Functions
// import formatDate from 'functions/format-date'

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'
import OrderList from 'views/admin/sections/order-list'

// Services
import companyServices from 'services/company'

// Fixed Data
import customOrderTypes from 'data/custom-order-types'

const AccountDetail = (props) => {
	const clientID = props.match.params.id;
	const defaultOrderQuery = {
		page: 1,
		sort_by: 'created_at',
		search_value: '',
		client_code: clientID,
	}

	const [data, setData] = useState(false);
	const [orderQuery, setOrderQuery] = useState(defaultOrderQuery)

	const getData = useCallback(() => {
		setData(false);
		companyServices.getClient(clientID).then((payload) => {
			let customOrderMatch = customOrderTypes.find((type) => (
				type.value === payload.custom_order
			));

			setData({
				...payload,
				custom_order_text: customOrderMatch ? customOrderMatch.label : payload.custom_order,
			});
		});

		// getInstallmentOptions(clientID);
	}, [clientID]);

	const searchOrders = (newQuery) => {
		setOrderQuery({...defaultOrderQuery, ...newQuery});
	}

	const paginateOrders = (page) => {
		searchOrders({...orderQuery, page: page});
	}

	useEffect(() => {
		getData();
	}, [clientID, getData])

	return (
		<main className="page client-detail">
			<Breadcrumbs
				midSections={[
					{href: 'clients'}
				]} />
			<section className="portlet section detail-info loader-container">
				<Loader loading={!data} />
				{data &&
					<React.Fragment>
						<div className="portlet-header">
							<h1 className="portlet-title">
								<span>{(data.invoice_type === 2 && data.company_name) ? data.company_name : (data.executive_name + ' ' + data.executive_surname)}</span>
								{(data.invoice_type === 2 && data.company_name) &&
									<span className="title-subtitle">{data.executive_name} {data.executive_surname}</span>
								}
								{data.invoice_type === 1 ?
									<label className="label dark">
										Bireysel
									</label>
									:
									<label className="label">
										Kurumsal
									</label>
								}
								{data.client_code === 'anonim' &&
									<label className="label error">
										Anonim Müşteri
									</label>
								}
							</h1>

							<div className="header-controls">
								<Btn
									white small wide
									onClick={() => { openModal('client', { clientID: clientID, onSuccess: getData }); }}
									icon="edit">
									Bilgileri Düzenle
								</Btn>
							</div>
						</div>

						<div className="portlet-section">
							<div className="portlet-infobar">
								<div className="grid-container">
									<div className="row">
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Tamamlanmış Talep Sayısı</strong>
												<span className="section-data big">
													{data.order_count_done}
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Aktif Talep Sayısı</strong>
												<span className="section-data big">
													{data.order_count_active}
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Alınan Ödemeler</strong>
												{data.order_payment_amount.length === 0 ?
													<div className="section-data big section detail-currencypayments">
														-
													</div>
												:
													<div className="section-data section detail-currencypayments">
														{data.order_payment_amount.map((amount, nth) => (
															<p key={nth} className="currencypayments-currency">
																<Pricebox
																	big
																	price={amount.total_price}
																	currency={amount.currency_symbol} />
																<Pricebox
																	price={amount.total_refund_price}
																	currency={amount.currency_symbol}
																	afterText="iade" />

																<span className="currency-amount">
																	{amount.total_payment_count} Ödeme
																</span>
															</p>
														))}
													</div>
												}
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Bekleyen Ödemeler</strong>
												{data.order_payment_amount.length === 0 ?
													<div className="section-data big section detail-currencypayments">
														-
													</div>
												:
													<div className="section-data section detail-currencypayments">
														{data.order_remaining_amount.map((amount, nth) => (
															<p key={nth} className="currencypayments-currency">
																<Pricebox
																	big
																	price={amount.total_remaining_amount}
																	currency={amount.currency_symbol} />

																<span className="currency-amount">
																	{amount.order_count} Ödeme
																</span>
															</p>
														))}
													</div>
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="portlet-section bottom border-top">
							<div className="portlet-infobar horizontal">
								<div className="grid-container">
									<strong className="infobar-title">Hesap Bilgileri</strong>
									<div className="row">
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">{data.invoice_type === 2 ? 'Yetkili' : 'Müşteri'} Adı Soyadı</strong>
												<span className="section-data">
													{data.executive_name} {data.executive_surname}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">Firma Kısa Adı</strong>
												<span className="section-data">
													{data.company_name}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">Cari Kodu</strong>
												<span className="section-data">
													{data.client_code}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">E-Posta</strong>
												<span className="section-data">
													{data.email}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">Telefon</strong>
												<span className="section-data">
													{data.phone_number}
												</span>
											</div>
										</div>
										<div className="col x6">
											{data.invoice_type === 2 ?
												<React.Fragment>
													<div className="infobar-section">
														<strong className="section-title">Vergi Numarası</strong>
														<span className="section-data">
															{data.tax_number ? data.tax_number : '-'}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Vergi Dairesi</strong>
														<span className="section-data">
															{data.tax_office ? data.tax_office : '-'}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Vergi Ünvanı</strong>
														<span className="section-data">
															{data.invoice_name ? data.invoice_name : '-'}
														</span>
													</div>
												</React.Fragment>:
												<React.Fragment>
													<div className="infobar-section">
														<strong className="section-title">TC Kimlik No</strong>
														<span className="section-data">
															{data.identity_number ? data.identity_number : '-'}
														</span>
													</div>
												</React.Fragment>
											}

											<div className="infobar-section">
												<strong className="section-title">Fatura Adresi</strong>
												<span className="section-data">
													{data.invoice_address ? <>
														{data.invoice_name && <><strong>{data.invoice_name}</strong>, </>}{data.invoice_address}{data.invoice_district && <>, {data.invoice_district}/</>}{data.invoice_city && <>{data.invoice_city}</>}
													</> : '-'}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">Serbest Ödeme Özelliği</strong>
												<span className="section-data">
													{data.custom_order_text}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</React.Fragment>
				}
			</section>

			{data &&
				<OrderList
					clientID={clientID}
					onSearch={searchOrders}
					onPaginate={paginateOrders}
					initialFiltersOpen={true}
					query={orderQuery} />
			}
		</main>
	)
}

export default AccountDetail